(function () {
  function parseConfig(root) {
    var node = root.querySelector('[data-low-stock-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function sellableFor(config, variant) {
    if (!variant || !variant.tracked || variant.qty === null || typeof variant.qty === 'undefined') {
      return null;
    }
    // Products tagged inventoryoff bypass the floor — intentional, not redundant.
    if (config.inventoryOff) return variant.qty;
    return variant.qty - config.falseFloor;
  }

  function unitLabel(config, variant) {
    if (!config.enabled || !variant || variant.policy === 'continue') return '';

    var sellable = sellableFor(config, variant);
    // Silence on bad data or non-positive sellable for a purchasable row.
    if (sellable === null || sellable <= 0 || !variant.available) return '';
    if (sellable > config.sizeThreshold) return '';
    if (sellable === 1) return config.strings.lastOne;
    return config.strings.unitsLeft.replace('__COUNT__', String(sellable));
  }

  function aggregateSellable(config) {
    var total = 0;
    config.variants.forEach(function (variant) {
      var sellable = sellableFor(config, variant);
      if (sellable !== null && sellable > 0) total += sellable;
    });
    return total;
  }

  function noticeLabel(config) {
    var total = aggregateSellable(config);
    if (total > 0 && total <= config.noticeNumber) {
      return config.noticeLanguage || '';
    }
    return '';
  }

  // Option inputs are associated via form="..." and often live outside the <form>,
  // so query within the picker (and prefer :checked for radio swatches).
  function getSelectedOptions(picker) {
    var options = [];
    var index = 1;

    while (index <= 3) {
      var inputs = picker.querySelectorAll('[name="option' + index + '"]');
      if (!inputs.length) break;

      var value = null;
      inputs.forEach(function (input) {
        if (input.type === 'radio') {
          if (input.checked) value = input.value;
        } else if (value === null) {
          value = input.value;
        }
      });

      if (value === null && inputs[0]) value = inputs[0].value;
      options[index - 1] = value;
      index += 1;
    }

    return options;
  }

  function findVariant(config, optionValues) {
    return config.variants.find(function (variant) {
      return variant.options.every(function (value, index) {
        return optionValues[index] === value;
      });
    });
  }

  function findVariantForSize(config, optionValues, sizePosition, sizeValue) {
    var next = optionValues.slice();
    next[sizePosition - 1] = sizeValue;
    var exact = findVariant(config, next);
    if (exact) return exact;

    // Fallback when other options aren't readable yet: unique variant for this size.
    var matches = config.variants.filter(function (variant) {
      return variant.options[sizePosition - 1] === sizeValue;
    });
    if (matches.length === 1) return matches[0];
    return null;
  }

  function updateRollup(picker, config) {
    var node = picker.querySelector('[data-sizes-left]');
    if (!node) return;
    node.textContent = noticeLabel(config);
  }

  function updateSizeOptions(picker, config) {
    if (!config.enabled || !config.sizePosition) return;

    var selected = getSelectedOptions(picker);
    var fieldset = picker.querySelector('[data-low-stock-size-fieldset]');
    if (!fieldset) return;

    fieldset.querySelectorAll('[data-option-value]').forEach(function (button) {
      var sizeValue = button.value;
      var qtyNode = button.querySelector('[data-size-qty]');
      if (!qtyNode) return;

      var variant = findVariantForSize(config, selected, config.sizePosition, sizeValue);
      // Don't wipe Liquid-rendered counts when lookup fails.
      if (!variant) return;

      var label = unitLabel(config, variant);
      if (label) {
        qtyNode.textContent = label;
        qtyNode.hidden = false;
      } else {
        qtyNode.textContent = '';
        qtyNode.hidden = true;
      }
    });
  }

  function initPicker(picker) {
    var config = parseConfig(picker);
    if (!config || !config.enabled) return;

    var formId = picker.getAttribute('form');
    var form = formId ? document.getElementById(formId) : picker.closest('form');

    var refresh = function () {
      updateRollup(picker, config);
      updateSizeOptions(picker, config);
    };

    if (form) form.addEventListener('variant:change', refresh);
    picker.querySelectorAll('[data-option-selector] input[name^="option"]').forEach(function (input) {
      input.addEventListener('change', function () {
        window.setTimeout(refresh, 0);
      });
    });

    refresh();
  }

  function init() {
    document.querySelectorAll('variant-picker[data-low-stock-picker]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
